export default __webpack_public_path__ + "static/media/06.c1b24b11.jpg";